import React from 'react';
import './styles.css';
import { Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { useRouteMatch, useHistory } from "react-router-dom";
import TestImage from '@BUP/assets/Images/Resources/ClassRoomActivities/1_3basic.jpeg'

const ClassRoomElement = ({ level }) => {
  const history = useHistory();
  const match = useRouteMatch();

  return (
    <div className="classroom-element-container">
      <div className="image-wrapper">
        <img
          src={level?.imgUrl || TestImage}
          alt={`level-image-${level.id}`}
        />
      </div>
      <div className="classroom-wrapper">
        <h2 className="h2-tag">{level?.name || "Sin Nombre"}</h2>
        <Button
          type="primary"
          shape="round"
          onClick={() => history.push(`${match.url}/level/${level.id}`)}
        >
          VER <ArrowRightOutlined />
        </Button>
      </div>
    </div>
  )
}

export default ClassRoomElement;